import { OrganizationSetting } from "@mapmycustomers/shared";
import Setting from "@mapmycustomers/shared/types/Setting";
import User from "@mapmycustomers/shared/types/User";

import UserLocationSettingVisibility from "@app/enum/UserLocationSettingVisibility";
import { isManager, isOwner } from "@app/store/iam/util";

const isUserLocationLayerAvailable = (
  currentUser: User,
  settings: Setting[] | undefined,
  hasFieldViewAddon: boolean
): boolean => {
  if (!hasFieldViewAddon) {
    return false;
  }

  const visibleSetting = settings?.find(
    ({ key }) => key === OrganizationSetting.USER_LOCATION_VISIBILITY
  );

  if (!visibleSetting) {
    return false;
  }

  const value: UserLocationSettingVisibility = visibleSetting.value;
  if (value === UserLocationSettingVisibility.NONE) {
    return false;
  }
  if (value === UserLocationSettingVisibility.OWNER_MANAGER) {
    return isOwner(currentUser) || isManager(currentUser);
  }
  if (value === UserLocationSettingVisibility.OWNER) {
    return isOwner(currentUser);
  }

  return true;
};

export default isUserLocationLayerAvailable;
